// Barrel: maps the 11 spec schema names (§3.1 templates/autopilot/*.schema.json
// list) + `proposed-change-content` (2026-09-15, the applier's content shape)
// to their zod schema exports. Single source the generator, the parity tests
// and `avatar autopilot schema <name>` iterate over — adding a schema means
// adding one entry here (and bumping the count pins in schema-parity.test.ts
// + the pack's layout/tarball tests).

import type { ZodType } from "zod";
import { BindingSchema } from "./binding-schema.js";
import { CompatibilitySchema } from "./compatibility-schema.js";
import { AutopilotConfigSchema } from "./config-schema.js";
import { DirectiveSchema } from "./directive-schema.js";
import { EventSchema } from "./event-schema.js";
import { InitRequestSchema } from "./init-schema.js";
import { InterviewSchema } from "./interview-schema.js";
import { MissionSchema } from "./mission-schema.js";
import { ReleaseSchema } from "./release-schema.js";
import { AutopilotResultSchema } from "./result-schema.js";
import { ProposedChangeContentSchema, TicketSchema } from "./ticket-schema.js";
import { VerificationProfileSchema } from "./verification-schema.js";

export const AUTOPILOT_SCHEMAS: Record<string, ZodType> = {
  mission: MissionSchema,
  ticket: TicketSchema,
  "proposed-change-content": ProposedChangeContentSchema,
  result: AutopilotResultSchema,
  init: InitRequestSchema,
  directive: DirectiveSchema,
  interview: InterviewSchema,
  event: EventSchema,
  release: ReleaseSchema,
  config: AutopilotConfigSchema,
  compatibility: CompatibilitySchema,
  verification: VerificationProfileSchema,
  binding: BindingSchema,
};

export const AUTOPILOT_SCHEMA_NAMES: readonly string[] = Object.keys(AUTOPILOT_SCHEMAS).sort();
